// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/offline_queries.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PlanAggregateBackfillResponse } from "../../aggregate/v1/service_pb";
import { file_chalk_aggregate_v1_service } from "../../aggregate/v1/service_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { ChalkError } from "../../common/v1/chalk_error_pb";
import { file_chalk_common_v1_chalk_error } from "../../common/v1/chalk_error_pb";
import type { DatasetResponse } from "../../common/v1/dataset_response_pb";
import { file_chalk_common_v1_dataset_response } from "../../common/v1/dataset_response_pb";
import type { OfflineQueryRequest } from "../../common/v1/offline_query_pb";
import { file_chalk_common_v1_offline_query } from "../../common/v1/offline_query_pb";
import type { WorkflowExecutionStatus } from "./dataplaneworkflows_pb";
import { file_chalk_server_v1_dataplaneworkflows } from "./dataplaneworkflows_pb";
import type { DatasetRevisionMeta } from "./datasets_pb";
import { file_chalk_server_v1_datasets } from "./datasets_pb";
import type { ListOfflineQueryShardPerformanceSummariesRequestSchema, ListOfflineQueryShardPerformanceSummariesResponseSchema } from "./performance_summary_pb";
import { file_chalk_server_v1_performance_summary } from "./performance_summary_pb";
import type { FieldMask, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/offline_queries.proto.
 */
export const file_chalk_server_v1_offline_queries: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_aggregate_v1_service, file_chalk_auth_v1_permissions, file_chalk_common_v1_chalk_error, file_chalk_common_v1_dataset_response, file_chalk_common_v1_offline_query, file_chalk_server_v1_dataplaneworkflows, file_chalk_server_v1_datasets, file_chalk_server_v1_performance_summary, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.OfflineQueryShardRun
 */
export type OfflineQueryShardRun = Message<"chalk.server.v1.OfflineQueryShardRun"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string offline_query_id = 2;
   */
  offlineQueryId: string;

  /**
   * @generated from field: int32 shard_id = 3;
   */
  shardId: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string hostname = 5;
   */
  hostname?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_execution_start = 6;
   */
  planExecutionStart?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 7;
   */
  completedAt?: Timestamp;

  /**
   * query_plans.id of the plan this attempt built. Every attempt of every shard plans
   * independently, so this differs per attempt even when the plans are structurally identical.
   *
   * @generated from field: optional string query_plan_id = 8;
   */
  queryPlanId?: string;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryShardRun.
 * Use `create(OfflineQueryShardRunSchema)` to create a new message.
 */
export const OfflineQueryShardRunSchema: GenMessage<OfflineQueryShardRun> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 0);

/**
 * @generated from message chalk.server.v1.OfflineQueryShard
 */
export type OfflineQueryShard = Message<"chalk.server.v1.OfflineQueryShard"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string offline_query_id = 2;
   */
  offlineQueryId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional int32 shard_id = 6;
   */
  shardId?: number;

  /**
   * @generated from field: optional int32 computer_id = 7;
   */
  computerId?: number;

  /**
   * @generated from field: optional string spine_uri = 8;
   */
  spineUri?: string;

  /**
   * @generated from field: optional int32 spine_uri_version = 9;
   */
  spineUriVersion?: number;

  /**
   * @generated from field: optional bool has_errors = 10;
   */
  hasErrors?: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 11;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryStatus status = 12;
   */
  status?: OfflineQueryStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_heartbeat_at = 13;
   */
  lastHeartbeatAt?: Timestamp;

  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryShardRun runs = 15;
   */
  runs: OfflineQueryShardRun[];

  /**
   * query_plans.id of the plan built by this shard's newest attempt; per-attempt ids are on
   * `runs`.
   *
   * @generated from field: optional string query_plan_id = 16;
   */
  queryPlanId?: string;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryShard.
 * Use `create(OfflineQueryShardSchema)` to create a new message.
 */
export const OfflineQueryShardSchema: GenMessage<OfflineQueryShard> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 1);

/**
 * @generated from message chalk.server.v1.OfflineQueryMeta
 */
export type OfflineQueryMeta = Message<"chalk.server.v1.OfflineQueryMeta"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Value query_meta = 6;
   */
  queryMeta?: Value;

  /**
   * @generated from field: optional string query_plan_id = 7;
   */
  queryPlanId?: string;

  /**
   * @generated from field: optional string branch_name = 8;
   */
  branchName?: string;

  /**
   * @generated from field: optional string dataset_id = 9;
   */
  datasetId?: string;

  /**
   * @generated from field: optional string dataset_name = 10;
   */
  datasetName?: string;

  /**
   * @generated from field: optional bool has_errors = 11;
   */
  hasErrors?: boolean;

  /**
   * @generated from field: optional string agent_id = 12;
   */
  agentId?: string;

  /**
   * @generated from field: optional string trace_id = 13;
   */
  traceId?: string;

  /**
   * @generated from field: optional string correlation_id = 14;
   */
  correlationId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 15;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryStatus status = 16;
   */
  status?: OfflineQueryStatus;

  /**
   * @generated from field: bool has_plan_stages = 17;
   */
  hasPlanStages: boolean;

  /**
   * @generated from field: optional int32 total_computers = 18;
   */
  totalComputers?: number;

  /**
   * @generated from field: optional int32 num_completed_computers = 19;
   */
  numCompletedComputers?: number;

  /**
   * @generated from field: optional int32 total_partitions = 20;
   */
  totalPartitions?: number;

  /**
   * @generated from field: optional int32 num_completed_partitions = 21;
   */
  numCompletedPartitions?: number;

  /**
   * @generated from field: optional string recompute_features = 22;
   */
  recomputeFeatures?: string;

  /**
   * @generated from field: optional string spine_sql_query = 23;
   */
  spineSqlQuery?: string;

  /**
   * @generated from field: optional google.protobuf.Value filters = 24;
   */
  filters?: Value;

  /**
   * @generated from field: optional google.protobuf.Value planner_options = 25;
   */
  plannerOptions?: Value;

  /**
   * @generated from field: optional google.protobuf.Value invoker_options = 26;
   */
  invokerOptions?: Value;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryKind query_type = 27;
   */
  queryType?: OfflineQueryKind;

  /**
   * @generated from field: repeated string tags = 28;
   */
  tags: string[];

  /**
   * @generated from field: repeated string required_resolver_tags = 29;
   */
  requiredResolverTags: string[];

  /**
   * @generated from field: optional string aggregate_backfill_id = 30;
   */
  aggregateBackfillId?: string;

  /**
   * @generated from field: optional google.protobuf.Value output = 31;
   */
  output?: Value;

  /**
   * @generated from field: optional google.protobuf.Value required_output = 32;
   */
  requiredOutput?: Value;

  /**
   * @generated from field: optional string raw_body_filename = 33;
   */
  rawBodyFilename?: string;

  /**
   * @generated from field: optional chalk.server.v1.DatasetRevisionMeta dataset_revision = 34;
   */
  datasetRevision?: DatasetRevisionMeta;

  /**
   * @generated from field: repeated chalk.aggregate.v1.PlanAggregateBackfillResponse time_series = 35;
   */
  timeSeries: PlanAggregateBackfillResponse[];

  /**
   * @generated from field: optional string evaluation_run_id = 36;
   */
  evaluationRunId?: string;

  /**
   * @generated from field: optional string query_name = 37;
   */
  queryName?: string;

  /**
   * @generated from field: optional string query_name_version = 38;
   */
  queryNameVersion?: string;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryJobQueueStats job_queue_stats = 39;
   */
  jobQueueStats?: OfflineQueryJobQueueStats;

  /**
   * @generated from field: optional string resource_group = 40;
   */
  resourceGroup?: string;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryStageTiming stage_timing = 41;
   */
  stageTiming?: OfflineQueryStageTiming;

  /**
   * Root FQNs of the features supplied as query inputs (the spine's feature
   * columns). Empty for queries with no input, e.g. bounds- or dataset-driven
   * ones. This is the only record of the input shape that survives the query:
   * the raw request body only names the uploaded parquet URIs, which live in
   * the customer's bucket.
   *
   * @generated from field: repeated string input_root_fqns = 42;
   */
  inputRootFqns: string[];

  /**
   * Present when this offline query is the referenced operation of a workflow.
   * The pre-queue interval is attributable to that workflow's metaplanning.
   *
   * @generated from field: optional string referencing_workflow_execution_id = 43;
   */
  referencingWorkflowExecutionId?: string;

  /**
   * Status of the workflow execution named by referencing_workflow_execution_id.
   * A workflow can be WORKING (e.g. metaplanning) while this query is still QUEUED.
   *
   * @generated from field: optional chalk.server.v1.WorkflowExecutionStatus referencing_workflow_execution_status = 44;
   */
  referencingWorkflowExecutionStatus?: WorkflowExecutionStatus;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryMeta.
 * Use `create(OfflineQueryMetaSchema)` to create a new message.
 */
export const OfflineQueryMetaSchema: GenMessage<OfflineQueryMeta> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 2);

/**
 * Job-queue stage boundaries for one offline query, reduced across its shards
 * and attempts. Unset when the query has no job-queue rows.
 *
 * @generated from message chalk.server.v1.OfflineQueryStageTiming
 */
export type OfflineQueryStageTiming = Message<"chalk.server.v1.OfflineQueryStageTiming"> & {
  /**
   * Earliest of job_queue.created_at and job_queue_attempts.queued_at.
   *
   * @generated from field: optional google.protobuf.Timestamp queue_started_at = 1;
   */
  queueStartedAt?: Timestamp;

  /**
   * Earliest job_queue_attempts.started_at. Not job_queue.last_attempted_at,
   * which is MAX(attempt.started_at) and so moves forward on every retry.
   *
   * @generated from field: optional google.protobuf.Timestamp execution_started_at = 2;
   */
  executionStartedAt?: Timestamp;

  /**
   * Latest of job_queue.finalized_at and job_queue_attempts.finished_at.
   *
   * @generated from field: optional google.protobuf.Timestamp execution_finished_at = 3;
   */
  executionFinishedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryStageTiming.
 * Use `create(OfflineQueryStageTimingSchema)` to create a new message.
 */
export const OfflineQueryStageTimingSchema: GenMessage<OfflineQueryStageTiming> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 3);

/**
 * @generated from message chalk.server.v1.OfflineQueryJobQueueStats
 */
export type OfflineQueryJobQueueStats = Message<"chalk.server.v1.OfflineQueryJobQueueStats"> & {
  /**
   * Pending is the sum of scheduled, waiting, and not-ready job queue rows.
   *
   * @generated from field: int32 pending_jobs = 1;
   */
  pendingJobs: number;

  /**
   * @generated from field: int32 running_jobs = 2;
   */
  runningJobs: number;

  /**
   * @generated from field: int32 completed_jobs = 3;
   */
  completedJobs: number;

  /**
   * @generated from field: int32 failed_jobs = 4;
   */
  failedJobs: number;

  /**
   * @generated from field: int32 canceled_jobs = 5;
   */
  canceledJobs: number;

  /**
   * @generated from field: int32 scheduled_jobs = 6;
   */
  scheduledJobs: number;

  /**
   * @generated from field: int32 waiting_jobs = 7;
   */
  waitingJobs: number;

  /**
   * @generated from field: int32 not_ready_jobs = 8;
   */
  notReadyJobs: number;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryJobQueueStats.
 * Use `create(OfflineQueryJobQueueStatsSchema)` to create a new message.
 */
export const OfflineQueryJobQueueStatsSchema: GenMessage<OfflineQueryJobQueueStats> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 4);

/**
 * @generated from message chalk.server.v1.ListOfflineQueriesRequest
 */
export type ListOfflineQueriesRequest = Message<"chalk.server.v1.ListOfflineQueriesRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional string start_date = 3;
   */
  startDate?: string;

  /**
   * @generated from field: optional string end_date = 4;
   */
  endDate?: string;

  /**
   * Substring match on operation_id or correlation_id; use operation_id_filter or correlation_id_filter.
   *
   * @generated from field: optional string id_filter = 5 [deprecated = true];
   * @deprecated
   */
  idFilter?: string;

  /**
   * @generated from field: optional string agent_id_filter = 6;
   */
  agentIdFilter?: string;

  /**
   * @generated from field: optional string branch_filter = 7;
   */
  branchFilter?: string;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryKind kind_filter = 8;
   */
  kindFilter?: OfflineQueryKind;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryStatus status_filter = 9;
   */
  statusFilter?: OfflineQueryStatus;

  /**
   * @generated from field: optional string aggregation_backfill_id_filter = 10;
   */
  aggregationBackfillIdFilter?: string;

  /**
   * @generated from field: optional string evaluation_run_id_filter = 11;
   */
  evaluationRunIdFilter?: string;

  /**
   * @generated from field: optional string query_name = 12;
   */
  queryName?: string;

  /**
   * @generated from field: optional string query_name_version = 13;
   */
  queryNameVersion?: string;

  /**
   * @generated from field: repeated string resource_groups = 14;
   */
  resourceGroups: string[];

  /**
   * @generated from field: repeated string agent_ids = 15;
   */
  agentIds: string[];

  /**
   * @generated from field: repeated string branch_filters = 16;
   */
  branchFilters: string[];

  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryKind kind_filters = 17;
   */
  kindFilters: OfflineQueryKind[];

  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryStatus status_filters = 18;
   */
  statusFilters: OfflineQueryStatus[];

  /**
   * @generated from field: repeated string query_names = 19;
   */
  queryNames: string[];

  /**
   * Exact match on operation_id.
   *
   * @generated from field: optional string operation_id_filter = 20;
   */
  operationIdFilter?: string;

  /**
   * Exact match on correlation_id.
   *
   * @generated from field: optional string correlation_id_filter = 21;
   */
  correlationIdFilter?: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueriesRequest.
 * Use `create(ListOfflineQueriesRequestSchema)` to create a new message.
 */
export const ListOfflineQueriesRequestSchema: GenMessage<ListOfflineQueriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 5);

/**
 * @generated from message chalk.server.v1.ListOfflineQueriesResponse
 */
export type ListOfflineQueriesResponse = Message<"chalk.server.v1.ListOfflineQueriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryMeta offline_queries = 1;
   */
  offlineQueries: OfflineQueryMeta[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueriesResponse.
 * Use `create(ListOfflineQueriesResponseSchema)` to create a new message.
 */
export const ListOfflineQueriesResponseSchema: GenMessage<ListOfflineQueriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 6);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryRequest
 */
export type GetOfflineQueryRequest = Message<"chalk.server.v1.GetOfflineQueryRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryRequest.
 * Use `create(GetOfflineQueryRequestSchema)` to create a new message.
 */
export const GetOfflineQueryRequestSchema: GenMessage<GetOfflineQueryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 7);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryResponse
 */
export type GetOfflineQueryResponse = Message<"chalk.server.v1.GetOfflineQueryResponse"> & {
  /**
   * @generated from field: chalk.server.v1.OfflineQueryMeta offline_query = 1;
   */
  offlineQuery?: OfflineQueryMeta;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryResponse.
 * Use `create(GetOfflineQueryResponseSchema)` to create a new message.
 */
export const GetOfflineQueryResponseSchema: GenMessage<GetOfflineQueryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 8);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryRequestBodyRequest
 */
export type GetOfflineQueryRequestBodyRequest = Message<"chalk.server.v1.GetOfflineQueryRequestBodyRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryRequestBodyRequest.
 * Use `create(GetOfflineQueryRequestBodyRequestSchema)` to create a new message.
 */
export const GetOfflineQueryRequestBodyRequestSchema: GenMessage<GetOfflineQueryRequestBodyRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 9);

/**
 * @generated from message chalk.server.v1.ShardRequestBodyJsonString
 */
export type ShardRequestBodyJsonString = Message<"chalk.server.v1.ShardRequestBodyJsonString"> & {
  /**
   * @generated from field: int32 shard_id = 1;
   */
  shardId: number;

  /**
   * @generated from field: optional string shard_request_body_json_string = 2;
   */
  shardRequestBodyJsonString?: string;
};

/**
 * Describes the message chalk.server.v1.ShardRequestBodyJsonString.
 * Use `create(ShardRequestBodyJsonStringSchema)` to create a new message.
 */
export const ShardRequestBodyJsonStringSchema: GenMessage<ShardRequestBodyJsonString> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 10);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryRequestBodyResponse
 */
export type GetOfflineQueryRequestBodyResponse = Message<"chalk.server.v1.GetOfflineQueryRequestBodyResponse"> & {
  /**
   * @generated from field: string request_body_json_string = 1;
   */
  requestBodyJsonString: string;

  /**
   * Per-shard worker request bodies loaded from the dataset revision download links.
   *
   * @generated from field: repeated chalk.server.v1.ShardRequestBodyJsonString shard_request_body = 2;
   */
  shardRequestBody: ShardRequestBodyJsonString[];
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryRequestBodyResponse.
 * Use `create(GetOfflineQueryRequestBodyResponseSchema)` to create a new message.
 */
export const GetOfflineQueryRequestBodyResponseSchema: GenMessage<GetOfflineQueryRequestBodyResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 11);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryShardsFilters
 */
export type ListOfflineQueryShardsFilters = Message<"chalk.server.v1.ListOfflineQueryShardsFilters"> & {
  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryStatus status = 1;
   */
  status?: OfflineQueryStatus;

  /**
   * @generated from field: optional int32 shard_id = 2;
   */
  shardId?: number;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardsFilters.
 * Use `create(ListOfflineQueryShardsFiltersSchema)` to create a new message.
 */
export const ListOfflineQueryShardsFiltersSchema: GenMessage<ListOfflineQueryShardsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 12);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryShardsPageToken
 */
export type ListOfflineQueryShardsPageToken = Message<"chalk.server.v1.ListOfflineQueryShardsPageToken"> & {
  /**
   * @generated from field: int32 shard_id = 1;
   */
  shardId: number;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardsPageToken.
 * Use `create(ListOfflineQueryShardsPageTokenSchema)` to create a new message.
 */
export const ListOfflineQueryShardsPageTokenSchema: GenMessage<ListOfflineQueryShardsPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 13);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryShardsRequest
 */
export type ListOfflineQueryShardsRequest = Message<"chalk.server.v1.ListOfflineQueryShardsRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;

  /**
   * @generated from field: optional chalk.server.v1.ListOfflineQueryShardsFilters filters = 3;
   */
  filters?: ListOfflineQueryShardsFilters;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * Must be encoded ListOfflineQueryShardsPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string page_token = 5;
   */
  pageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardsRequest.
 * Use `create(ListOfflineQueryShardsRequestSchema)` to create a new message.
 */
export const ListOfflineQueryShardsRequestSchema: GenMessage<ListOfflineQueryShardsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 14);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryShardsResponse
 */
export type ListOfflineQueryShardsResponse = Message<"chalk.server.v1.ListOfflineQueryShardsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryShard offline_query_shards = 1;
   */
  offlineQueryShards: OfflineQueryShard[];

  /**
   * encoded ListOfflineQueryShardsPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardsResponse.
 * Use `create(ListOfflineQueryShardsResponseSchema)` to create a new message.
 */
export const ListOfflineQueryShardsResponseSchema: GenMessage<ListOfflineQueryShardsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 15);

/**
 * @generated from message chalk.server.v1.OfflineQueryShardStatusAggregate
 */
export type OfflineQueryShardStatusAggregate = Message<"chalk.server.v1.OfflineQueryShardStatusAggregate"> & {
  /**
   * @generated from field: chalk.server.v1.OfflineQueryStatus status = 1;
   */
  status: OfflineQueryStatus;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryShardStatusAggregate.
 * Use `create(OfflineQueryShardStatusAggregateSchema)` to create a new message.
 */
export const OfflineQueryShardStatusAggregateSchema: GenMessage<OfflineQueryShardStatusAggregate> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 16);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryShardsAggregatedRequest
 */
export type GetOfflineQueryShardsAggregatedRequest = Message<"chalk.server.v1.GetOfflineQueryShardsAggregatedRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryShardsAggregatedRequest.
 * Use `create(GetOfflineQueryShardsAggregatedRequestSchema)` to create a new message.
 */
export const GetOfflineQueryShardsAggregatedRequestSchema: GenMessage<GetOfflineQueryShardsAggregatedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 17);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryShardsAggregatedResponse
 */
export type GetOfflineQueryShardsAggregatedResponse = Message<"chalk.server.v1.GetOfflineQueryShardsAggregatedResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryShardStatusAggregate aggregates = 1;
   */
  aggregates: OfflineQueryShardStatusAggregate[];
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryShardsAggregatedResponse.
 * Use `create(GetOfflineQueryShardsAggregatedResponseSchema)` to create a new message.
 */
export const GetOfflineQueryShardsAggregatedResponseSchema: GenMessage<GetOfflineQueryShardsAggregatedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 18);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryInfraSummaryRequest
 */
export type GetOfflineQueryInfraSummaryRequest = Message<"chalk.server.v1.GetOfflineQueryInfraSummaryRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryInfraSummaryRequest.
 * Use `create(GetOfflineQueryInfraSummaryRequestSchema)` to create a new message.
 */
export const GetOfflineQueryInfraSummaryRequestSchema: GenMessage<GetOfflineQueryInfraSummaryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 19);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryInfraSummaryResponse
 */
export type GetOfflineQueryInfraSummaryResponse = Message<"chalk.server.v1.GetOfflineQueryInfraSummaryResponse"> & {
  /**
   * @generated from field: repeated string pod_names = 1;
   */
  podNames: string[];
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryInfraSummaryResponse.
 * Use `create(GetOfflineQueryInfraSummaryResponseSchema)` to create a new message.
 */
export const GetOfflineQueryInfraSummaryResponseSchema: GenMessage<GetOfflineQueryInfraSummaryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 20);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryProfileSummaryRequest
 */
export type GetOfflineQueryProfileSummaryRequest = Message<"chalk.server.v1.GetOfflineQueryProfileSummaryRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryProfileSummaryRequest.
 * Use `create(GetOfflineQueryProfileSummaryRequestSchema)` to create a new message.
 */
export const GetOfflineQueryProfileSummaryRequestSchema: GenMessage<GetOfflineQueryProfileSummaryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 21);

/**
 * @generated from message chalk.server.v1.OfflineQueryProfilePercentileStats
 */
export type OfflineQueryProfilePercentileStats = Message<"chalk.server.v1.OfflineQueryProfilePercentileStats"> & {
  /**
   * @generated from field: double p50 = 1;
   */
  p50: number;

  /**
   * @generated from field: double p75 = 2;
   */
  p75: number;

  /**
   * @generated from field: double p90 = 3;
   */
  p90: number;

  /**
   * @generated from field: double p99 = 4;
   */
  p99: number;

  /**
   * @generated from field: double p_max = 5;
   */
  pMax: number;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryProfilePercentileStats.
 * Use `create(OfflineQueryProfilePercentileStatsSchema)` to create a new message.
 */
export const OfflineQueryProfilePercentileStatsSchema: GenMessage<OfflineQueryProfilePercentileStats> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 22);

/**
 * @generated from message chalk.server.v1.OfflineQueryProfileSummaryRow
 */
export type OfflineQueryProfileSummaryRow = Message<"chalk.server.v1.OfflineQueryProfileSummaryRow"> & {
  /**
   * Where we sourced this metric (i.e. metrics1, offline query performance summary JSON, etc)
   *
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * Name of the metric
   *
   * @generated from field: string metric = 2;
   */
  metric: string;

  /**
   * How many samples made up the stats
   *
   * @generated from field: int32 count = 3;
   */
  count: number;

  /**
   * Actual stats
   *
   * @generated from field: chalk.server.v1.OfflineQueryProfilePercentileStats stats = 4;
   */
  stats?: OfflineQueryProfilePercentileStats;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryProfileSummaryRow.
 * Use `create(OfflineQueryProfileSummaryRowSchema)` to create a new message.
 */
export const OfflineQueryProfileSummaryRowSchema: GenMessage<OfflineQueryProfileSummaryRow> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 23);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryProfileSummaryResponse
 */
export type GetOfflineQueryProfileSummaryResponse = Message<"chalk.server.v1.GetOfflineQueryProfileSummaryResponse"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * Status of the requested query
   *
   * @generated from field: chalk.server.v1.OfflineQueryStatus status = 2;
   */
  status: OfflineQueryStatus;

  /**
   * How many shard the query ran with
   *
   * @generated from field: int32 shard_count = 3;
   */
  shardCount: number;

  /**
   * Number of shards that reported a performance summary
   *
   * @generated from field: int32 performance_shards = 4;
   */
  performanceShards: number;

  /**
   * Names of the pods that ran the query
   *
   * @generated from field: repeated string pod_names = 5;
   */
  podNames: string[];

  /**
   * The actual aggregated metric data
   *
   * @generated from field: repeated chalk.server.v1.OfflineQueryProfileSummaryRow rows = 6;
   */
  rows: OfflineQueryProfileSummaryRow[];

  /**
   * Warnings about the data
   *
   * @generated from field: repeated string warnings = 7;
   */
  warnings: string[];
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryProfileSummaryResponse.
 * Use `create(GetOfflineQueryProfileSummaryResponseSchema)` to create a new message.
 */
export const GetOfflineQueryProfileSummaryResponseSchema: GenMessage<GetOfflineQueryProfileSummaryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 24);

/**
 * @generated from message chalk.server.v1.OfflineQueryUtilizationStats
 */
export type OfflineQueryUtilizationStats = Message<"chalk.server.v1.OfflineQueryUtilizationStats"> & {
  /**
   * Highest bucket value observed in the query's metric window
   *
   * @generated from field: double peak = 1;
   */
  peak: number;

  /**
   * Mean over all (pod, bucket) samples in the window
   *
   * @generated from field: double average = 2;
   */
  average: number;

  /**
   * Lowest bucket value observed in the window
   *
   * @generated from field: double min = 3;
   */
  min: number;

  /**
   * Number of (pod, bucket) samples behind these stats
   *
   * @generated from field: int32 sample_count = 4;
   */
  sampleCount: number;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryUtilizationStats.
 * Use `create(OfflineQueryUtilizationStatsSchema)` to create a new message.
 */
export const OfflineQueryUtilizationStatsSchema: GenMessage<OfflineQueryUtilizationStats> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 25);

/**
 * Infrastructure placement of one pod that executed (part of) an offline
 * query, sourced from job_queue_consumers. CPU/memory values are Kubernetes
 * resource quantities (e.g. "16", "64Gi").
 *
 * @generated from message chalk.server.v1.OfflineQueryPodInfo
 */
export type OfflineQueryPodInfo = Message<"chalk.server.v1.OfflineQueryPodInfo"> & {
  /**
   * @generated from field: string pod_name = 1;
   */
  podName: string;

  /**
   * @generated from field: optional string resource_group = 2;
   */
  resourceGroup?: string;

  /**
   * @generated from field: optional string node_name = 3;
   */
  nodeName?: string;

  /**
   * @generated from field: optional string instance_type = 4;
   */
  instanceType?: string;

  /**
   * node CPU capacity
   *
   * @generated from field: optional string node_cpu = 5;
   */
  nodeCpu?: string;

  /**
   * node memory capacity
   *
   * @generated from field: optional string node_memory = 6;
   */
  nodeMemory?: string;

  /**
   * pod CPU request
   *
   * @generated from field: optional string cpu_request = 7;
   */
  cpuRequest?: string;

  /**
   * pod memory request
   *
   * @generated from field: optional string memory_request = 8;
   */
  memoryRequest?: string;
};

/**
 * Describes the message chalk.server.v1.OfflineQueryPodInfo.
 * Use `create(OfflineQueryPodInfoSchema)` to create a new message.
 */
export const OfflineQueryPodInfoSchema: GenMessage<OfflineQueryPodInfo> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 26);

/**
 * @generated from message chalk.server.v1.OfflineQueryUtilizationSummary
 */
export type OfflineQueryUtilizationSummary = Message<"chalk.server.v1.OfflineQueryUtilizationSummary"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: optional string query_name = 2;
   */
  queryName?: string;

  /**
   * @generated from field: chalk.server.v1.OfflineQueryStatus status = 3;
   */
  status: OfflineQueryStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 5;
   */
  completedAt?: Timestamp;

  /**
   * Host CPU utilization, in the same unit as the cpu_utilization_percent
   * chart series rendered on the offline query metrics page.
   *
   * @generated from field: optional chalk.server.v1.OfflineQueryUtilizationStats cpu = 6;
   */
  cpu?: OfflineQueryUtilizationStats;

  /**
   * Fraction of host memory used by the query's pods:
   * memory_usage_bytes / host_memory_bytes, in [0, 1].
   *
   * @generated from field: optional chalk.server.v1.OfflineQueryUtilizationStats memory = 7;
   */
  memory?: OfflineQueryUtilizationStats;

  /**
   * Fraction of host disk in use on the query's pods:
   * the fullest mounted filesystem's used/(used + available), in [0, 1].
   *
   * @generated from field: optional chalk.server.v1.OfflineQueryUtilizationStats disk = 8;
   */
  disk?: OfflineQueryUtilizationStats;

  /**
   * @generated from field: repeated string warnings = 9;
   */
  warnings: string[];

  /**
   * Distinct resource groups the query ran in, from job_queue rows for this
   * operation, falling back to the pods' job_queue_consumers rows.
   *
   * @generated from field: repeated string resource_groups = 10;
   */
  resourceGroups: string[];

  /**
   * Per-pod node placement and resource requests, where known.
   *
   * @generated from field: repeated chalk.server.v1.OfflineQueryPodInfo pods = 11;
   */
  pods: OfflineQueryPodInfo[];
};

/**
 * Describes the message chalk.server.v1.OfflineQueryUtilizationSummary.
 * Use `create(OfflineQueryUtilizationSummarySchema)` to create a new message.
 */
export const OfflineQueryUtilizationSummarySchema: GenMessage<OfflineQueryUtilizationSummary> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 27);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryUtilizationSummariesRequest
 */
export type GetOfflineQueryUtilizationSummariesRequest = Message<"chalk.server.v1.GetOfflineQueryUtilizationSummariesRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * Maximum number of offline queries to summarize in this page, newest first.
   * The server applies its own per-page cap; page through the rest with
   * next_cursor.
   *
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * Opaque cursor from a previous response's next_cursor. Summaries resume
   * strictly older than the cursor, in the same descending created_at order.
   *
   * @generated from field: optional string cursor = 4;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryUtilizationSummariesRequest.
 * Use `create(GetOfflineQueryUtilizationSummariesRequestSchema)` to create a new message.
 */
export const GetOfflineQueryUtilizationSummariesRequestSchema: GenMessage<GetOfflineQueryUtilizationSummariesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 28);

/**
 * @generated from message chalk.server.v1.GetOfflineQueryUtilizationSummariesResponse
 */
export type GetOfflineQueryUtilizationSummariesResponse = Message<"chalk.server.v1.GetOfflineQueryUtilizationSummariesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.OfflineQueryUtilizationSummary summaries = 1;
   */
  summaries: OfflineQueryUtilizationSummary[];

  /**
   * @generated from field: repeated string warnings = 2;
   */
  warnings: string[];

  /**
   * True when more offline queries existed in the range than were summarized.
   *
   * @generated from field: bool truncated = 3;
   */
  truncated: boolean;

  /**
   * Set when more offline queries remain; pass it back as the request's cursor
   * to fetch the next page.
   *
   * @generated from field: optional string next_cursor = 4;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineQueryUtilizationSummariesResponse.
 * Use `create(GetOfflineQueryUtilizationSummariesResponseSchema)` to create a new message.
 */
export const GetOfflineQueryUtilizationSummariesResponseSchema: GenMessage<GetOfflineQueryUtilizationSummariesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 29);

/**
 * One time bucket of aggregated host utilization for a single resource group.
 * The stats are computed over every (pod, sub-bucket) sample that fell in
 * [bucket_start, bucket_start + bucket_duration).
 *
 * @generated from message chalk.server.v1.ResourceGroupUtilizationBucket
 */
export type ResourceGroupUtilizationBucket = Message<"chalk.server.v1.ResourceGroupUtilizationBucket"> & {
  /**
   * @generated from field: google.protobuf.Timestamp bucket_start = 1;
   */
  bucketStart?: Timestamp;

  /**
   * Host CPU utilization over the bucket, in the same unit as the
   * cpu_utilization_percent chart series (percent of the pod's CPU allocation).
   *
   * @generated from field: optional chalk.server.v1.OfflineQueryUtilizationStats cpu = 2;
   */
  cpu?: OfflineQueryUtilizationStats;

  /**
   * Fraction of host memory used over the bucket:
   * memory_usage_bytes / host_memory_bytes, in [0, 1].
   *
   * @generated from field: optional chalk.server.v1.OfflineQueryUtilizationStats memory = 3;
   */
  memory?: OfflineQueryUtilizationStats;

  /**
   * Fraction of host disk in use over the bucket:
   * the fullest mounted filesystem's used/(used + available), in [0, 1].
   *
   * @generated from field: optional chalk.server.v1.OfflineQueryUtilizationStats disk = 4;
   */
  disk?: OfflineQueryUtilizationStats;
};

/**
 * Describes the message chalk.server.v1.ResourceGroupUtilizationBucket.
 * Use `create(ResourceGroupUtilizationBucketSchema)` to create a new message.
 */
export const ResourceGroupUtilizationBucketSchema: GenMessage<ResourceGroupUtilizationBucket> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 30);

/**
 * A per-resource-group utilization time series over the requested window.
 *
 * @generated from message chalk.server.v1.ResourceGroupUtilizationSeries
 */
export type ResourceGroupUtilizationSeries = Message<"chalk.server.v1.ResourceGroupUtilizationSeries"> & {
  /**
   * @generated from field: string resource_group = 1;
   */
  resourceGroup: string;

  /**
   * Ordered oldest-first; only buckets with at least one sample are emitted.
   *
   * @generated from field: repeated chalk.server.v1.ResourceGroupUtilizationBucket buckets = 2;
   */
  buckets: ResourceGroupUtilizationBucket[];

  /**
   * @generated from field: repeated string warnings = 3;
   */
  warnings: string[];
};

/**
 * Describes the message chalk.server.v1.ResourceGroupUtilizationSeries.
 * Use `create(ResourceGroupUtilizationSeriesSchema)` to create a new message.
 */
export const ResourceGroupUtilizationSeriesSchema: GenMessage<ResourceGroupUtilizationSeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 31);

/**
 * @generated from message chalk.server.v1.GetResourceGroupUtilizationTimeseriesRequest
 */
export type GetResourceGroupUtilizationTimeseriesRequest = Message<"chalk.server.v1.GetResourceGroupUtilizationTimeseriesRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * Width of each output bucket as a Go duration ("1h", "30m", "1d"...).
   * Defaults to 1h. The server picks a finer sampling rollup internally and
   * aggregates it up to this width.
   *
   * @generated from field: optional string bucket_duration = 3;
   */
  bucketDuration?: string;

  /**
   * When set, only these resource groups are returned. When empty, every
   * resource group observed in the window is returned.
   *
   * @generated from field: repeated string resource_groups = 4;
   */
  resourceGroups: string[];
};

/**
 * Describes the message chalk.server.v1.GetResourceGroupUtilizationTimeseriesRequest.
 * Use `create(GetResourceGroupUtilizationTimeseriesRequestSchema)` to create a new message.
 */
export const GetResourceGroupUtilizationTimeseriesRequestSchema: GenMessage<GetResourceGroupUtilizationTimeseriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 32);

/**
 * @generated from message chalk.server.v1.GetResourceGroupUtilizationTimeseriesResponse
 */
export type GetResourceGroupUtilizationTimeseriesResponse = Message<"chalk.server.v1.GetResourceGroupUtilizationTimeseriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ResourceGroupUtilizationSeries series = 1;
   */
  series: ResourceGroupUtilizationSeries[];

  /**
   * @generated from field: repeated string warnings = 2;
   */
  warnings: string[];

  /**
   * The effective bucket width the server used, echoed back for rendering.
   *
   * @generated from field: string bucket_duration = 3;
   */
  bucketDuration: string;
};

/**
 * Describes the message chalk.server.v1.GetResourceGroupUtilizationTimeseriesResponse.
 * Use `create(GetResourceGroupUtilizationTimeseriesResponseSchema)` to create a new message.
 */
export const GetResourceGroupUtilizationTimeseriesResponseSchema: GenMessage<GetResourceGroupUtilizationTimeseriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 33);

/**
 * One time bucket of job-queue activity for a single resource group. Counts and
 * request totals reflect the jobs that were *active* (scheduled but not yet
 * finalized) at any point during [bucket_start, bucket_start + bucket_duration).
 *
 * @generated from message chalk.server.v1.ResourceGroupJobBucket
 */
export type ResourceGroupJobBucket = Message<"chalk.server.v1.ResourceGroupJobBucket"> & {
  /**
   * @generated from field: google.protobuf.Timestamp bucket_start = 1;
   */
  bucketStart?: Timestamp;

  /**
   * Number of job-queue rows (offline query shards) active in the bucket.
   *
   * @generated from field: int32 shard_count = 2;
   */
  shardCount: number;

  /**
   * Number of distinct offline queries (operation ids) active in the bucket.
   *
   * @generated from field: int32 query_count = 3;
   */
  queryCount: number;

  /**
   * Sum of the active jobs' requested CPU, in cores.
   *
   * @generated from field: double cpu_request_cores = 4;
   */
  cpuRequestCores: number;

  /**
   * Sum of the active jobs' requested memory, in bytes.
   *
   * @generated from field: double memory_request_bytes = 5;
   */
  memoryRequestBytes: number;
};

/**
 * Describes the message chalk.server.v1.ResourceGroupJobBucket.
 * Use `create(ResourceGroupJobBucketSchema)` to create a new message.
 */
export const ResourceGroupJobBucketSchema: GenMessage<ResourceGroupJobBucket> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 34);

/**
 * A per-resource-group job-queue activity time series over the requested window.
 *
 * @generated from message chalk.server.v1.ResourceGroupJobSeries
 */
export type ResourceGroupJobSeries = Message<"chalk.server.v1.ResourceGroupJobSeries"> & {
  /**
   * @generated from field: string resource_group = 1;
   */
  resourceGroup: string;

  /**
   * Ordered oldest-first; only buckets with at least one active job are emitted.
   *
   * @generated from field: repeated chalk.server.v1.ResourceGroupJobBucket buckets = 2;
   */
  buckets: ResourceGroupJobBucket[];
};

/**
 * Describes the message chalk.server.v1.ResourceGroupJobSeries.
 * Use `create(ResourceGroupJobSeriesSchema)` to create a new message.
 */
export const ResourceGroupJobSeriesSchema: GenMessage<ResourceGroupJobSeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 35);

/**
 * @generated from message chalk.server.v1.GetResourceGroupJobTimeseriesRequest
 */
export type GetResourceGroupJobTimeseriesRequest = Message<"chalk.server.v1.GetResourceGroupJobTimeseriesRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * Width of each output bucket as a Go duration ("1h", "30m", "1d"...).
   * Defaults to 1h.
   *
   * @generated from field: optional string bucket_duration = 3;
   */
  bucketDuration?: string;

  /**
   * When set, only these resource groups are returned. When empty, every
   * resource group with activity in the window is returned.
   *
   * @generated from field: repeated string resource_groups = 4;
   */
  resourceGroups: string[];
};

/**
 * Describes the message chalk.server.v1.GetResourceGroupJobTimeseriesRequest.
 * Use `create(GetResourceGroupJobTimeseriesRequestSchema)` to create a new message.
 */
export const GetResourceGroupJobTimeseriesRequestSchema: GenMessage<GetResourceGroupJobTimeseriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 36);

/**
 * @generated from message chalk.server.v1.GetResourceGroupJobTimeseriesResponse
 */
export type GetResourceGroupJobTimeseriesResponse = Message<"chalk.server.v1.GetResourceGroupJobTimeseriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ResourceGroupJobSeries series = 1;
   */
  series: ResourceGroupJobSeries[];

  /**
   * @generated from field: repeated string warnings = 2;
   */
  warnings: string[];

  /**
   * The effective bucket width the server used, echoed back for rendering.
   *
   * @generated from field: string bucket_duration = 3;
   */
  bucketDuration: string;
};

/**
 * Describes the message chalk.server.v1.GetResourceGroupJobTimeseriesResponse.
 * Use `create(GetResourceGroupJobTimeseriesResponseSchema)` to create a new message.
 */
export const GetResourceGroupJobTimeseriesResponseSchema: GenMessage<GetResourceGroupJobTimeseriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 37);

/**
 * Idle vs busy worker capacity for one resource group in one time bucket.
 *
 * All *_seconds fields are TIME-WEIGHTED integrals over the bucket: a 64-core pod
 * alive for half of a 1h bucket contributes 64 * 1800 = 115200 provisioned core-seconds.
 * This deliberately differs from ResourceGroupJobBucket.cpu_request_cores, which adds a
 * pod's full cores to every bucket its lifetime touches without weighting by how much of
 * the bucket it was alive for. The two quantities are not comparable and must not be
 * charted on shared axes.
 *
 * @generated from message chalk.server.v1.ResourceGroupEfficiencyBucket
 */
export type ResourceGroupEfficiencyBucket = Message<"chalk.server.v1.ResourceGroupEfficiencyBucket"> & {
  /**
   * @generated from field: google.protobuf.Timestamp bucket_start = 1;
   */
  bucketStart?: Timestamp;

  /**
   * Wall-clock pod time, unweighted by pod size.
   *
   * @generated from field: double provisioned_pod_seconds = 2;
   */
  provisionedPodSeconds: number;

  /**
   * Measure of the *union* of attempt intervals across pods, clipped to the bucket. A
   * pod running several attempts at once contributes its wall-clock time once, not once
   * per attempt, so busy can never exceed provisioned.
   *
   * @generated from field: double busy_pod_seconds = 3;
   */
  busyPodSeconds: number;

  /**
   * @generated from field: double idle_pod_seconds = 4;
   */
  idlePodSeconds: number;

  /**
   * Pod time weighted by each pod's CPU request, in core-seconds.
   *
   * @generated from field: double provisioned_core_seconds = 5;
   */
  provisionedCoreSeconds: number;

  /**
   * @generated from field: double busy_core_seconds = 6;
   */
  busyCoreSeconds: number;

  /**
   * @generated from field: double idle_core_seconds = 7;
   */
  idleCoreSeconds: number;

  /**
   * Pod time weighted by each pod's memory request, in byte-seconds.
   *
   * @generated from field: double provisioned_byte_seconds = 8;
   */
  provisionedByteSeconds: number;

  /**
   * @generated from field: double busy_byte_seconds = 9;
   */
  busyByteSeconds: number;

  /**
   * @generated from field: double idle_byte_seconds = 10;
   */
  idleByteSeconds: number;

  /**
   * Distinct consumer pods that overlapped the bucket at all.
   *
   * @generated from field: int32 consumer_count = 11;
   */
  consumerCount: number;

  /**
   * Consumers excluded from the CPU and memory weightings respectively, counted
   * separately because a pod can declare one request and not the other.
   *
   * A request is unusable when it is absent -- job_queue_consumers.pod_requests is NULL
   * when the pod spec declares no tracked requests at all -- or when the recorded value
   * is not a parseable Kubernetes quantity. An explicit "0" is a real declaration and
   * counts as usable, not missing.
   *
   * Excluded pods still contribute their wall-clock time to the *_pod_seconds fields, so
   * the pod-time view stays complete. They contribute to neither the provisioned nor the
   * idle side of the weighting they are excluded from, so a nonzero count means that
   * weighting understates both reserved and idle capacity for this bucket.
   *
   * @generated from field: int32 cpu_unweighted_consumer_count = 12;
   */
  cpuUnweightedConsumerCount: number;

  /**
   * @generated from field: int32 memory_unweighted_consumer_count = 21;
   */
  memoryUnweightedConsumerCount: number;

  /**
   * Attempts that started in this bucket, whatever their outcome.
   *
   * @generated from field: int32 attempt_count = 13;
   */
  attemptCount: number;

  /**
   * @generated from field: int32 completed_attempt_count = 14;
   */
  completedAttemptCount: number;

  /**
   * @generated from field: int32 failed_attempt_count = 15;
   */
  failedAttemptCount: number;

  /**
   * Summed wall-clock duration of the attempts in finished_attempt_count. Divide by that
   * count for the mean; the two are reported separately so buckets can be summed before
   * averaging rather than averaging an average.
   *
   * @generated from field: double attempt_duration_seconds = 16;
   */
  attemptDurationSeconds: number;

  /**
   * Attempts that both started in this bucket and have finished, so their duration is
   * known. Still-running attempts are excluded from the duration total.
   *
   * @generated from field: int32 finished_attempt_count = 17;
   */
  finishedAttemptCount: number;

  /**
   * Distinct jobs (job_queue rows) with at least one attempt starting in this bucket. A
   * job that failed twice and then succeeded is one job and three attempts, so the two
   * success rates answer different questions: the job rate is "did the work get done",
   * the attempt rate is "how much capacity went into retries".
   *
   * job_count includes jobs whose job_queue row has since been archived out from under
   * a still-retained attempt: the work demonstrably ran. Those jobs appear in neither
   * completed_job_count nor failed_job_count, so an unknown outcome never scores as a
   * failure and never enters the rate's denominator.
   *
   * Job state is the job's state *now*, not its state during the bucket, because
   * job_queue stores only the current value. A job still running when the window closed
   * and finished afterwards will count as completed in a historical bucket.
   *
   * @generated from field: int32 job_count = 18;
   */
  jobCount: number;

  /**
   * @generated from field: int32 completed_job_count = 19;
   */
  completedJobCount: number;

  /**
   * @generated from field: int32 failed_job_count = 20;
   */
  failedJobCount: number;
};

/**
 * Describes the message chalk.server.v1.ResourceGroupEfficiencyBucket.
 * Use `create(ResourceGroupEfficiencyBucketSchema)` to create a new message.
 */
export const ResourceGroupEfficiencyBucketSchema: GenMessage<ResourceGroupEfficiencyBucket> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 38);

/**
 * Window-wide totals for one resource group.
 *
 * Job counts cannot be recovered by summing buckets: a job is counted in every bucket it
 * has an attempt starting in, so a job that retried across three buckets would total
 * three. That per-bucket attribution is deliberate -- collapsing a job to its first
 * bucket would erase later retry activity from the time series -- so the window total is
 * carried separately, deduplicated across the whole series.
 *
 * Attempt counts need no equivalent: each attempt belongs to exactly one starting bucket,
 * so summing those across buckets is already correct.
 *
 * @generated from message chalk.server.v1.ResourceGroupEfficiencySummary
 */
export type ResourceGroupEfficiencySummary = Message<"chalk.server.v1.ResourceGroupEfficiencySummary"> & {
  /**
   * @generated from field: int32 job_count = 1;
   */
  jobCount: number;

  /**
   * @generated from field: int32 completed_job_count = 2;
   */
  completedJobCount: number;

  /**
   * @generated from field: int32 failed_job_count = 3;
   */
  failedJobCount: number;
};

/**
 * Describes the message chalk.server.v1.ResourceGroupEfficiencySummary.
 * Use `create(ResourceGroupEfficiencySummarySchema)` to create a new message.
 */
export const ResourceGroupEfficiencySummarySchema: GenMessage<ResourceGroupEfficiencySummary> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 39);

/**
 * A per-resource-group efficiency time series over the requested window.
 *
 * @generated from message chalk.server.v1.ResourceGroupEfficiencySeries
 */
export type ResourceGroupEfficiencySeries = Message<"chalk.server.v1.ResourceGroupEfficiencySeries"> & {
  /**
   * @generated from field: string resource_group = 1;
   */
  resourceGroup: string;

  /**
   * Ordered oldest-first. Unlike ResourceGroupJobSeries, a bucket is emitted whenever
   * any consumer pod existed, even when no job ran in it: a wholly idle resource group
   * is the primary signal this RPC exists to report, so it must never come back as an
   * empty series.
   *
   * @generated from field: repeated chalk.server.v1.ResourceGroupEfficiencyBucket buckets = 2;
   */
  buckets: ResourceGroupEfficiencyBucket[];

  /**
   * @generated from field: repeated string warnings = 3;
   */
  warnings: string[];

  /**
   * Window totals. Use these for any job figure covering the whole range; summing the
   * per-bucket job counts double-counts jobs that span buckets.
   *
   * @generated from field: chalk.server.v1.ResourceGroupEfficiencySummary summary = 4;
   */
  summary?: ResourceGroupEfficiencySummary;
};

/**
 * Describes the message chalk.server.v1.ResourceGroupEfficiencySeries.
 * Use `create(ResourceGroupEfficiencySeriesSchema)` to create a new message.
 */
export const ResourceGroupEfficiencySeriesSchema: GenMessage<ResourceGroupEfficiencySeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 40);

/**
 * @generated from message chalk.server.v1.GetResourceGroupEfficiencyTimeseriesRequest
 */
export type GetResourceGroupEfficiencyTimeseriesRequest = Message<"chalk.server.v1.GetResourceGroupEfficiencyTimeseriesRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * Width of each output bucket as a Go duration ("1h", "30m", "1d"...). Defaults to 1h.
   *
   * @generated from field: optional string bucket_duration = 3;
   */
  bucketDuration?: string;

  /**
   * When set, only these resource groups are returned. When empty, every resource group
   * with a consumer pod in the window is returned.
   *
   * @generated from field: repeated string resource_groups = 4;
   */
  resourceGroups: string[];
};

/**
 * Describes the message chalk.server.v1.GetResourceGroupEfficiencyTimeseriesRequest.
 * Use `create(GetResourceGroupEfficiencyTimeseriesRequestSchema)` to create a new message.
 */
export const GetResourceGroupEfficiencyTimeseriesRequestSchema: GenMessage<GetResourceGroupEfficiencyTimeseriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 41);

/**
 * @generated from message chalk.server.v1.GetResourceGroupEfficiencyTimeseriesResponse
 */
export type GetResourceGroupEfficiencyTimeseriesResponse = Message<"chalk.server.v1.GetResourceGroupEfficiencyTimeseriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ResourceGroupEfficiencySeries series = 1;
   */
  series: ResourceGroupEfficiencySeries[];

  /**
   * @generated from field: repeated string warnings = 2;
   */
  warnings: string[];

  /**
   * The effective bucket width the server used, echoed back for rendering.
   *
   * @generated from field: string bucket_duration = 3;
   */
  bucketDuration: string;
};

/**
 * Describes the message chalk.server.v1.GetResourceGroupEfficiencyTimeseriesResponse.
 * Use `create(GetResourceGroupEfficiencyTimeseriesResponseSchema)` to create a new message.
 */
export const GetResourceGroupEfficiencyTimeseriesResponseSchema: GenMessage<GetResourceGroupEfficiencyTimeseriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 42);

/**
 * @generated from message chalk.server.v1.CreateOfflineQueryJobRequest
 */
export type CreateOfflineQueryJobRequest = Message<"chalk.server.v1.CreateOfflineQueryJobRequest"> & {
  /**
   * @generated from field: chalk.common.v1.OfflineQueryRequest offline_query_request = 1;
   */
  offlineQueryRequest?: OfflineQueryRequest;
};

/**
 * Describes the message chalk.server.v1.CreateOfflineQueryJobRequest.
 * Use `create(CreateOfflineQueryJobRequestSchema)` to create a new message.
 */
export const CreateOfflineQueryJobRequestSchema: GenMessage<CreateOfflineQueryJobRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 43);

/**
 * @generated from message chalk.server.v1.CreateOfflineQueryJobResponse
 */
export type CreateOfflineQueryJobResponse = Message<"chalk.server.v1.CreateOfflineQueryJobResponse"> & {
  /**
   * @generated from field: chalk.common.v1.DatasetResponse dataset_response = 1;
   */
  datasetResponse?: DatasetResponse;
};

/**
 * Describes the message chalk.server.v1.CreateOfflineQueryJobResponse.
 * Use `create(CreateOfflineQueryJobResponseSchema)` to create a new message.
 */
export const CreateOfflineQueryJobResponseSchema: GenMessage<CreateOfflineQueryJobResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 44);

/**
 * @generated from message chalk.server.v1.CreateModelTrainingJobRequest
 * @deprecated
 */
export type CreateModelTrainingJobRequest = Message<"chalk.server.v1.CreateModelTrainingJobRequest"> & {
  /**
   * @generated from field: chalk.common.v1.OfflineQueryRequest training_job_request = 1;
   */
  trainingJobRequest?: OfflineQueryRequest;
};

/**
 * Describes the message chalk.server.v1.CreateModelTrainingJobRequest.
 * Use `create(CreateModelTrainingJobRequestSchema)` to create a new message.
 * @deprecated
 */
export const CreateModelTrainingJobRequestSchema: GenMessage<CreateModelTrainingJobRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 45);

/**
 * @generated from message chalk.server.v1.CreateModelTrainingJobResponse
 * @deprecated
 */
export type CreateModelTrainingJobResponse = Message<"chalk.server.v1.CreateModelTrainingJobResponse"> & {
};

/**
 * Describes the message chalk.server.v1.CreateModelTrainingJobResponse.
 * Use `create(CreateModelTrainingJobResponseSchema)` to create a new message.
 * @deprecated
 */
export const CreateModelTrainingJobResponseSchema: GenMessage<CreateModelTrainingJobResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 46);

/**
 * @generated from message chalk.server.v1.IngestDatasetRequest
 */
export type IngestDatasetRequest = Message<"chalk.server.v1.IngestDatasetRequest"> & {
  /**
   * @generated from field: repeated string outputs = 1;
   */
  outputs: string[];

  /**
   * @generated from field: string revision_id = 2;
   */
  revisionId: string;

  /**
   * @generated from field: optional string branch = 3;
   */
  branch?: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> planner_options = 4;
   */
  plannerOptions: { [key: string]: Value };

  /**
   * @generated from field: bool store_online = 5;
   */
  storeOnline: boolean;

  /**
   * @generated from field: bool store_offline = 6;
   */
  storeOffline: boolean;

  /**
   * @generated from field: bool enable_profiling = 7;
   */
  enableProfiling: boolean;

  /**
   * @generated from field: optional string online_timestamping_mode = 8;
   */
  onlineTimestampingMode?: string;

  /**
   * @generated from field: optional bool explain = 9;
   */
  explain?: boolean;
};

/**
 * Describes the message chalk.server.v1.IngestDatasetRequest.
 * Use `create(IngestDatasetRequestSchema)` to create a new message.
 */
export const IngestDatasetRequestSchema: GenMessage<IngestDatasetRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 47);

/**
 * @generated from message chalk.server.v1.IngestDatasetResponse
 */
export type IngestDatasetResponse = Message<"chalk.server.v1.IngestDatasetResponse"> & {
  /**
   * @generated from field: chalk.common.v1.DatasetResponse dataset_response = 1;
   */
  datasetResponse?: DatasetResponse;
};

/**
 * Describes the message chalk.server.v1.IngestDatasetResponse.
 * Use `create(IngestDatasetResponseSchema)` to create a new message.
 */
export const IngestDatasetResponseSchema: GenMessage<IngestDatasetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 48);

/**
 * @generated from message chalk.server.v1.RetryOfflineQueryShardRequest
 */
export type RetryOfflineQueryShardRequest = Message<"chalk.server.v1.RetryOfflineQueryShardRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;

  /**
   * @generated from field: int32 shard_index = 2;
   */
  shardIndex: number;
};

/**
 * Describes the message chalk.server.v1.RetryOfflineQueryShardRequest.
 * Use `create(RetryOfflineQueryShardRequestSchema)` to create a new message.
 */
export const RetryOfflineQueryShardRequestSchema: GenMessage<RetryOfflineQueryShardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 49);

/**
 * @generated from message chalk.server.v1.RetryOfflineQueryShardResponse
 */
export type RetryOfflineQueryShardResponse = Message<"chalk.server.v1.RetryOfflineQueryShardResponse"> & {
};

/**
 * Describes the message chalk.server.v1.RetryOfflineQueryShardResponse.
 * Use `create(RetryOfflineQueryShardResponseSchema)` to create a new message.
 */
export const RetryOfflineQueryShardResponseSchema: GenMessage<RetryOfflineQueryShardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 50);

/**
 * @generated from message chalk.server.v1.CancelAsyncOfflineQueryRequest
 */
export type CancelAsyncOfflineQueryRequest = Message<"chalk.server.v1.CancelAsyncOfflineQueryRequest"> & {
  /**
   * @generated from field: string offline_query_id = 1;
   */
  offlineQueryId: string;
};

/**
 * Describes the message chalk.server.v1.CancelAsyncOfflineQueryRequest.
 * Use `create(CancelAsyncOfflineQueryRequestSchema)` to create a new message.
 */
export const CancelAsyncOfflineQueryRequestSchema: GenMessage<CancelAsyncOfflineQueryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 51);

/**
 * @generated from message chalk.server.v1.CancelAsyncOfflineQueryResponse
 */
export type CancelAsyncOfflineQueryResponse = Message<"chalk.server.v1.CancelAsyncOfflineQueryResponse"> & {
};

/**
 * Describes the message chalk.server.v1.CancelAsyncOfflineQueryResponse.
 * Use `create(CancelAsyncOfflineQueryResponseSchema)` to create a new message.
 */
export const CancelAsyncOfflineQueryResponseSchema: GenMessage<CancelAsyncOfflineQueryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 52);

/**
 * @generated from message chalk.server.v1.BatchProgress
 */
export type BatchProgress = Message<"chalk.server.v1.BatchProgress"> & {
  /**
   * @generated from field: string total = 1;
   */
  total: string;

  /**
   * @generated from field: string computed = 2;
   */
  computed: string;

  /**
   * @generated from field: string failed = 3;
   */
  failed: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp start = 4;
   */
  start?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end = 5;
   */
  end?: Timestamp;

  /**
   * @generated from field: double total_duration_s = 6;
   */
  totalDurationS: number;

  /**
   * @generated from field: string stored_online = 7;
   */
  storedOnline: string;

  /**
   * @generated from field: string stored_offline = 8;
   */
  storedOffline: string;
};

/**
 * Describes the message chalk.server.v1.BatchProgress.
 * Use `create(BatchProgressSchema)` to create a new message.
 */
export const BatchProgressSchema: GenMessage<BatchProgress> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 53);

/**
 * @generated from message chalk.server.v1.ChunkReport
 */
export type ChunkReport = Message<"chalk.server.v1.ChunkReport"> & {
  /**
   * @generated from field: chalk.server.v1.BatchProgress progress = 1;
   */
  progress?: BatchProgress;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 2;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.ChunkReport.
 * Use `create(ChunkReportSchema)` to create a new message.
 */
export const ChunkReportSchema: GenMessage<ChunkReport> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 54);

/**
 * @generated from message chalk.server.v1.BatchResolverReport
 */
export type BatchResolverReport = Message<"chalk.server.v1.BatchResolverReport"> & {
  /**
   * @generated from field: string resolver_fqn = 1;
   */
  resolverFqn: string;

  /**
   * @generated from field: chalk.server.v1.BatchOpStatus status = 2;
   */
  status: BatchOpStatus;

  /**
   * @generated from field: repeated chalk.server.v1.ChunkReport chunks = 3;
   */
  chunks: ChunkReport[];

  /**
   * @generated from field: chalk.server.v1.BatchProgress progress = 4;
   */
  progress?: BatchProgress;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 5;
   */
  generatedAt?: Timestamp;

  /**
   * @generated from field: optional chalk.common.v1.ChalkError error = 6;
   */
  error?: ChalkError;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError all_errors = 7;
   */
  allErrors: ChalkError[];
};

/**
 * Describes the message chalk.server.v1.BatchResolverReport.
 * Use `create(BatchResolverReportSchema)` to create a new message.
 */
export const BatchResolverReportSchema: GenMessage<BatchResolverReport> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 55);

/**
 * @generated from message chalk.server.v1.BatchReport
 */
export type BatchReport = Message<"chalk.server.v1.BatchReport"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: chalk.server.v1.BatchOpKind operation_kind = 2;
   */
  operationKind: BatchOpKind;

  /**
   * @generated from field: chalk.server.v1.BatchOpStatus status = 3;
   */
  status: BatchOpStatus;

  /**
   * @generated from field: repeated chalk.server.v1.BatchResolverReport resolvers = 4;
   */
  resolvers: BatchResolverReport[];

  /**
   * @generated from field: chalk.server.v1.BatchProgress progress = 5;
   */
  progress?: BatchProgress;

  /**
   * @generated from field: string environment_id = 6;
   */
  environmentId: string;

  /**
   * @generated from field: string team_id = 7;
   */
  teamId: string;

  /**
   * @generated from field: string deployment_id = 8;
   */
  deploymentId: string;

  /**
   * @generated from field: optional chalk.common.v1.ChalkError error = 9;
   */
  error?: ChalkError;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 10;
   */
  generatedAt?: Timestamp;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError all_errors = 11;
   */
  allErrors: ChalkError[];

  /**
   * @generated from field: optional google.protobuf.Value operation_metadata = 12;
   */
  operationMetadata?: Value;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 13;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp ended_at = 14;
   */
  endedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.BatchReport.
 * Use `create(BatchReportSchema)` to create a new message.
 */
export const BatchReportSchema: GenMessage<BatchReport> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 56);

/**
 * @generated from message chalk.server.v1.GetBatchReportRequest
 */
export type GetBatchReportRequest = Message<"chalk.server.v1.GetBatchReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * Restrict resolver reports to a single shard/computer (unmerged). Shard 0 is
   * the canonical (computer-0) report. When unset, resolver reports come from
   * computer 0 unless get_mask names "resolvers".
   *
   * @generated from field: optional int32 shard_id = 2;
   */
  shardId?: number;

  /**
   * @generated from field: google.protobuf.FieldMask get_mask = 3;
   */
  getMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.GetBatchReportRequest.
 * Use `create(GetBatchReportRequestSchema)` to create a new message.
 */
export const GetBatchReportRequestSchema: GenMessage<GetBatchReportRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 57);

/**
 * @generated from message chalk.server.v1.GetBatchReportResponse
 */
export type GetBatchReportResponse = Message<"chalk.server.v1.GetBatchReportResponse"> & {
  /**
   * @generated from field: chalk.server.v1.BatchReport batch_report = 1;
   */
  batchReport?: BatchReport;
};

/**
 * Describes the message chalk.server.v1.GetBatchReportResponse.
 * Use `create(GetBatchReportResponseSchema)` to create a new message.
 */
export const GetBatchReportResponseSchema: GenMessage<GetBatchReportResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 58);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryNamesRequest
 */
export type ListOfflineQueryNamesRequest = Message<"chalk.server.v1.ListOfflineQueryNamesRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryNamesRequest.
 * Use `create(ListOfflineQueryNamesRequestSchema)` to create a new message.
 */
export const ListOfflineQueryNamesRequestSchema: GenMessage<ListOfflineQueryNamesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 59);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryNamesResponse
 */
export type ListOfflineQueryNamesResponse = Message<"chalk.server.v1.ListOfflineQueryNamesResponse"> & {
  /**
   * @generated from field: repeated string query_names = 1;
   */
  queryNames: string[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryNamesResponse.
 * Use `create(ListOfflineQueryNamesResponseSchema)` to create a new message.
 */
export const ListOfflineQueryNamesResponseSchema: GenMessage<ListOfflineQueryNamesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_offline_queries, 60);

/**
 * @generated from enum chalk.server.v1.OfflineQueryStatus
 */
export enum OfflineQueryStatus {
  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_WORKING = 2;
   */
  WORKING = 2,

  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_FAILED = 3;
   */
  FAILED = 3,

  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: OFFLINE_QUERY_STATUS_QUEUED = 6;
   */
  QUEUED = 6,
}

/**
 * Describes the enum chalk.server.v1.OfflineQueryStatus.
 */
export const OfflineQueryStatusSchema: GenEnum<OfflineQueryStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_offline_queries, 0);

/**
 * @generated from enum chalk.server.v1.OfflineQueryKind
 */
export enum OfflineQueryKind {
  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_ASYNC_OFFLINE_QUERY = 2;
   */
  ASYNC_OFFLINE_QUERY = 2,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_CRON_OFFLINE_QUERY = 3;
   */
  CRON_OFFLINE_QUERY = 3,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_OFFLINE_QUERY = 4;
   */
  OFFLINE_QUERY = 4,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_DATASET_INGESTION = 5;
   */
  DATASET_INGESTION = 5,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_AGGREGATION_BACKFILL = 6;
   */
  AGGREGATION_BACKFILL = 6,

  /**
   * @generated from enum value: OFFLINE_QUERY_KIND_TRAINING_JOB = 7;
   */
  TRAINING_JOB = 7,
}

/**
 * Describes the enum chalk.server.v1.OfflineQueryKind.
 */
export const OfflineQueryKindSchema: GenEnum<OfflineQueryKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_offline_queries, 1);

/**
 * @generated from enum chalk.server.v1.BatchOpStatus
 */
export enum BatchOpStatus {
  /**
   * @generated from enum value: BATCH_OP_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BATCH_OP_STATUS_INIT = 1;
   */
  INIT = 1,

  /**
   * @generated from enum value: BATCH_OP_STATUS_COMPUTE_STARTED = 2;
   */
  COMPUTE_STARTED = 2,

  /**
   * @generated from enum value: BATCH_OP_STATUS_COMPUTE_ENDED = 3;
   */
  COMPUTE_ENDED = 3,

  /**
   * @generated from enum value: BATCH_OP_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * @generated from enum value: BATCH_OP_STATUS_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum chalk.server.v1.BatchOpStatus.
 */
export const BatchOpStatusSchema: GenEnum<BatchOpStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_offline_queries, 2);

/**
 * @generated from enum chalk.server.v1.BatchOpKind
 */
export enum BatchOpKind {
  /**
   * @generated from enum value: BATCH_OP_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BATCH_OP_KIND_OFFLINE_QUERY = 1;
   */
  OFFLINE_QUERY = 1,

  /**
   * @generated from enum value: BATCH_OP_KIND_RECOMPUTE = 2;
   */
  RECOMPUTE = 2,

  /**
   * @generated from enum value: BATCH_OP_KIND_CRON = 3;
   */
  CRON = 3,

  /**
   * @generated from enum value: BATCH_OP_KIND_AGGREGATION_BACKFILL = 4;
   */
  AGGREGATION_BACKFILL = 4,
}

/**
 * Describes the enum chalk.server.v1.BatchOpKind.
 */
export const BatchOpKindSchema: GenEnum<BatchOpKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_offline_queries, 3);

/**
 * @generated from service chalk.server.v1.OfflineQueryMetadataService
 */
export const OfflineQueryMetadataService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueries
   */
  listOfflineQueries: {
    methodKind: "unary";
    input: typeof ListOfflineQueriesRequestSchema;
    output: typeof ListOfflineQueriesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQuery
   */
  getOfflineQuery: {
    methodKind: "unary";
    input: typeof GetOfflineQueryRequestSchema;
    output: typeof GetOfflineQueryResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryRequestBody
   */
  getOfflineQueryRequestBody: {
    methodKind: "unary";
    input: typeof GetOfflineQueryRequestBodyRequestSchema;
    output: typeof GetOfflineQueryRequestBodyResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueryShards
   */
  listOfflineQueryShards: {
    methodKind: "unary";
    input: typeof ListOfflineQueryShardsRequestSchema;
    output: typeof ListOfflineQueryShardsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryShardsAggregated
   */
  getOfflineQueryShardsAggregated: {
    methodKind: "unary";
    input: typeof GetOfflineQueryShardsAggregatedRequestSchema;
    output: typeof GetOfflineQueryShardsAggregatedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryInfraSummary
   */
  getOfflineQueryInfraSummary: {
    methodKind: "unary";
    input: typeof GetOfflineQueryInfraSummaryRequestSchema;
    output: typeof GetOfflineQueryInfraSummaryResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryProfileSummary
   */
  getOfflineQueryProfileSummary: {
    methodKind: "unary";
    input: typeof GetOfflineQueryProfileSummaryRequestSchema;
    output: typeof GetOfflineQueryProfileSummaryResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryUtilizationSummaries
   */
  getOfflineQueryUtilizationSummaries: {
    methodKind: "unary";
    input: typeof GetOfflineQueryUtilizationSummariesRequestSchema;
    output: typeof GetOfflineQueryUtilizationSummariesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetResourceGroupUtilizationTimeseries
   */
  getResourceGroupUtilizationTimeseries: {
    methodKind: "unary";
    input: typeof GetResourceGroupUtilizationTimeseriesRequestSchema;
    output: typeof GetResourceGroupUtilizationTimeseriesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetResourceGroupJobTimeseries
   */
  getResourceGroupJobTimeseries: {
    methodKind: "unary";
    input: typeof GetResourceGroupJobTimeseriesRequestSchema;
    output: typeof GetResourceGroupJobTimeseriesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetResourceGroupEfficiencyTimeseries
   */
  getResourceGroupEfficiencyTimeseries: {
    methodKind: "unary";
    input: typeof GetResourceGroupEfficiencyTimeseriesRequestSchema;
    output: typeof GetResourceGroupEfficiencyTimeseriesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueryShardPerformanceSummaries
   */
  listOfflineQueryShardPerformanceSummaries: {
    methodKind: "unary";
    input: typeof ListOfflineQueryShardPerformanceSummariesRequestSchema;
    output: typeof ListOfflineQueryShardPerformanceSummariesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.CreateOfflineQueryJob
   */
  createOfflineQueryJob: {
    methodKind: "unary";
    input: typeof CreateOfflineQueryJobRequestSchema;
    output: typeof CreateOfflineQueryJobResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.CreateModelTrainingJob
   * @deprecated
   */
  createModelTrainingJob: {
    methodKind: "unary";
    input: typeof CreateModelTrainingJobRequestSchema;
    output: typeof CreateModelTrainingJobResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.IngestDataset
   */
  ingestDataset: {
    methodKind: "unary";
    input: typeof IngestDatasetRequestSchema;
    output: typeof IngestDatasetResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.RetryOfflineQueryShard
   */
  retryOfflineQueryShard: {
    methodKind: "unary";
    input: typeof RetryOfflineQueryShardRequestSchema;
    output: typeof RetryOfflineQueryShardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.CancelAsyncOfflineQuery
   */
  cancelAsyncOfflineQuery: {
    methodKind: "unary";
    input: typeof CancelAsyncOfflineQueryRequestSchema;
    output: typeof CancelAsyncOfflineQueryResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetBatchReport
   */
  getBatchReport: {
    methodKind: "unary";
    input: typeof GetBatchReportRequestSchema;
    output: typeof GetBatchReportResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueryNames
   */
  listOfflineQueryNames: {
    methodKind: "unary";
    input: typeof ListOfflineQueryNamesRequestSchema;
    output: typeof ListOfflineQueryNamesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_offline_queries, 0);

